// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFoundPage_notFound__270Vs"};